import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";
import jQuery from "jquery";
const $ = jQuery;
// single shared poller so re-rendering the page never stacks timers
let domainVerifyTimer:number|undefined;
export class ZIDXAccountSiteDomain implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountSiteDomainContainer";
    }
    render(){
        let self=this;
        // console.log("site domain");
        $(".revertCustomDomainLink", self.zidx.peakidxShadowRoot).off("click").on("click", function(this:HTMLElement, e){
            e.preventDefault();
            $("#idx_site_domain_unverified", self.zidx.peakidxShadowRoot).val($(this).attr("data-previous") as string);
            $(".zidxAccountSiteDomainContainer .zidxForm button", self.zidx.peakidxShadowRoot).trigger("click");
        });
        $(".purgeCDNCacheLink", self.zidx.peakidxShadowRoot).off("click").on("click", function(this:HTMLElement, e){
            e.preventDefault();
            let obj = {
                id: "ajaxDomainPurge",
                method: "get",
                postObj: {},
                ignoreOldRequests: false,
                callback: function (r: string) {
                    let js = JSON.parse(r);
                    if (js.success) {
                        $(".zidxAccountSiteDomainContainer .purgeCDNCacheStatus", self.zidx.peakidxShadowRoot).html(js.data);
                    } else {
                        $(".zidxAccountSiteDomainContainer .purgeCDNCacheStatus", self.zidx.peakidxShadowRoot).html(js.errorMessage);
                    }
                },
                errorCallback: function (e: XMLHttpRequest) {
                    $(".zidxAccountSiteDomainContainer .purgeCDNCacheStatus", self.zidx.peakidxShadowRoot).html("There was a temporary problem. Please try again later.");
                },
                url: "/account/sites/domain/purge",
            };
            self.zidx.ajaxRequest(obj);
        });

        if($(".zidxAccountSiteDomainContainer .domainVerificationContainer", self.zidx.peakidxShadowRoot).length!=0) {
            let params = new URL(window.location.href).searchParams;
            let lastResult = "";
            if(domainVerifyTimer!==undefined){
                window.clearTimeout(domainVerifyTimer);
                domainVerifyTimer=undefined;
            }
            const schedule=function(){
                domainVerifyTimer=window.setTimeout(poll, 5000);
            };
            const poll=function () {
                domainVerifyTimer=undefined;
                if($(".zidxAccountSiteDomainContainer .domainVerificationContainer", self.zidx.peakidxShadowRoot).length==0){
                    return; // page is gone, stop polling
                }
                let obj = {
                    id: "ajaxDomainVerify",
                    method: "get",
                    postObj: {},
                    ignoreOldRequests: false,
                    callback: function (r: string) {
                        schedule();
                        if (lastResult == r) {
                            return;
                        }
                        lastResult = r;
                        let js = JSON.parse(r);
                        if (js.success) {
                            $(".zidxAccountSiteDomainContainer .domainVerificationContainer", self.zidx.peakidxShadowRoot).html(js.data);
                        } else {
                            $(".zidxAccountSiteDomainContainer .domainVerificationContainer", self.zidx.peakidxShadowRoot).html("<h3>Sorry, there was a temporary problem</h3><p>Unable to verify domains at this time. Check your connection and try again later.</p>");
                        }
                    },
                    errorCallback: function (e: XMLHttpRequest) {
                        schedule();
                        $(".zidxAccountSiteDomainContainer .domainVerificationContainer", self.zidx.peakidxShadowRoot).html("<h3>Sorry, there was a temporary problem</h3><p>Unable to verify domains at this time. Check your connection and try again later.</p>");
                    },
                    url: '/account/sites/domain/verify?idx_site_id=' + params.get("idx_site_id"),
                };
                self.zidx.ajaxRequest(obj);
            };
            schedule();
        }
    }
}